module.exports = __webpack_public_path__ + "static/media/1POLICY21.5ace9b96.jpg";